var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('v-progress-circular',{attrs:{"size":80,"width":7,"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }